<template>
  <block-title
    class="abnormal-monitoring overview"
    :show-line="false"
    title="异常监控"
  >
    <el-row :gutter="24" class="monitoring-list">
      <template v-for="item in abnormalList">
        <el-col
        v-if="!item.isVerify||isShowSensitiveFields(item.value)"
        :key="item.value"
        class="monitoring-list-item"
      >
        <div :class="{'active-item': exceptionStatus[item.value]}" :style="`background-image: url(${item.img})`" @click="toDetail(item)">
          <div>
            {{item.label}}
            <a-tooltip class="list-item-tip" :title="item.tip">
              <a-icon type="exclamation-circle" theme="filled" />
            </a-tooltip>
          </div>
          <div>
            <div :class="['monitoring-value', 'monitoring', exceptionStatus[item.value] > 0 ? 'fail' : '']">
              {{exceptionStatus[item.value]}}
            </div>
          </div>
        </div>
      </el-col>
      </template>
    </el-row>
  </block-title>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import base from '@/api/base'
import moment from 'moment'
import { mapState } from 'vuex'
import { getExceptionStats, getTemperatureExceptionStats, getOrderAlarm } from '../api'
import pricePng from '../imgs/pic_jifeiyc.png'
import outboundPng from '../imgs/pic_chukuyc.png'
import dispatchPng from '../imgs/pic_paichecs.png'
import pickPng from '../imgs/pic_quhuocs.png'
import signPng from '../imgs/pic_qianshoucs.png'
import temperaturePng from '../imgs/pic_wenduyc.png'
import warningPng from '../imgs/pic_warning.png'
import env from '../../../../../env/index'
import { abnormalData } from '../constant'

export default {
  name: 'AbnormalMonitoring',
  components: {
    BlockTitle
  },
  props: {
    isDemo: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      abnormalList: [
        {
          label: '计费异常',
          value: 'price_exception_num',
          tip: '状态为计费异常的订单',
          img: pricePng,
          path: '/data/priceEexception',
          type: 'PRICE',
          trackName: '计费异常点击',
        },
        {
          label: '出库异常',
          value: 'outbound_exception_num',
          tip: '出库单创建异常',
          img: outboundPng,
          path: '/data/outboundexception',
          type: 'OUTBOUND',
          trackName: '出库异常点击',
        },
        {
          label: '派车超时',
          value: 'dispatch_timeout_num',
          tip: '超过要求取货时间且未派车的订单',
          img: dispatchPng,
          path: '/data/dispatchTimeout',
          type: 'DISPATCH_TIMEOUT',
          trackName: '派车超时点击',
        },
        {
          label: '取货超时',
          value: 'pick_timeout_num',
          tip: '超过订单要求取货时间，派车后司机未取货',
          img: pickPng,
          path: '/data/pickTimeout',
          type: 'PICK_TIMEOUT',
          trackName: '取货超时点击',
        },
        {
          label: '签收超时',
          value: 'sign_timeout_num',
          tip: '超过期望送达时间订单未签收',
          img: signPng,
          path: '/data/signTtimeout',
          type: 'SIGN_TIMEOUT',
          trackName: '签收超时点击',
          isVerify: true, // 需要验证
        },
        {
          label: '温度异常',
          value: 'temperature_exception_cnt',
          tip: '超温时长10分钟以上的订单',
          img: temperaturePng,
          path: '/data/temperatureEexception',
          type: 'TEMPERATURE',
          trackName: '温度异常点击',
          isVerify: true, // 需要验证
        },
        {
          label: '轨迹预警',
          value: 'cargo_warning_num',
          tip: '近30天运输轨迹异常的订单',
          img: warningPng,
          path: '/data/cargoWarning',
          type: 'CARGO_WARNING',
          trackName: '轨迹预警点击',
          isVerify: true, // 需要验证
        }
      ],
      exceptionStatus: {}, // 异常数据
    }
  },
  computed:{
    ...mapState('orderRules', ['sensitiveFields']),
    isShowSensitiveFields(){
      return (field)=>{
       if(this.sensitiveFields&&this.sensitiveFields.SENSITIVE_FIELDS){
         const {dataOverviewSensitiveFields=[]} = this.sensitiveFields.SENSITIVE_FIELDS;
          return dataOverviewSensitiveFields.includes(field)
       }
       return false
      }
    }
  },
  created() {
    this.getDictionary()
  },
  methods: {
    async getDictionary() {
      if(this.isDemo) {
        const abnormalRes = await base.getDictionary({
          status: 1,
          type: 'board_except'
        })
        const data = {}
        abnormalRes.forEach(item => {
          data[abnormalData[item.dictionaryName]] = item.dictionaryCode
        })
        this.exceptionStatus = data
        return
      }
      this.getExceptionStats(this.isShowSensitiveFields('sign_timeout_num')||this.isShowSensitiveFields('temperature_exception_cnt'), this.isShowSensitiveFields('cargo_warning_num'))
    },
    async getExceptionStats(isWhiteList, isCargoWarning) {
       const {projectIds,creditCode,customers,customerCode}=this.$store.state.user
       const data={}
       if(creditCode){
         data.customerCodes=customers.map(item=>item.customerCode)
         data.projectIds=projectIds
       }else{
         data.customerCode=customerCode
          data.projectIds=projectIds
       }
      let exceptionStats = await getExceptionStats(data)
      if (isWhiteList) {
        const res = await getTemperatureExceptionStats(data)
        exceptionStats = {
          ...exceptionStats,
          ...res
        }
      }
      if(isCargoWarning) {
        const filter = {
          customerCodes: [this.$store.state.user.customerCode],
          ruleIds: env.ruleIds,
          startTime: moment().subtract(29, "days").startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        }
        const res = await getOrderAlarm({
          filter,
          paging: false
        })
        exceptionStats.cargo_warning_num = res.records?.[0]?.dataCount || 0
      }
      this.exceptionStatus = exceptionStats
    },
    toDetail(item) {
      const { value, path, type, trackName } = item
      if (this.exceptionStatus[value]) {
        YlTrack.report({
          trackName,
          trackType: 'click',
        });
        this.$router.push({
          path,
          query: {
            type
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.abnormal-monitoring {
  .monitoring-list {
    padding: 8px 32px 8px 32px;
    .monitoring-list-item {
      width: calc(100% / 7);
      > div {
        border: 1px solid #EBEDF0;
        background: #f4f4f4;
        border-radius: 6px;
        height: 121px;
        padding: 24px 0 0 36px;
        background-repeat: no-repeat;
        background-size: 80px 80px;
        background-position: bottom right;
        &.active-item {
          cursor: pointer;
          &:hover {
            box-shadow: 0px 10px 15px 2px rgba(114, 124, 133, 0.26);
          }
        }
        .list-item-tip {
          margin-left: 10px;
          color: #909399;
          font-size: 12px;
          cursor: pointer;
        }
        .monitoring-value {
          padding-top: 8px;
          font-size: 36px;
          font-weight: 500;
          color: #171717;
          line-height: 43px;
          &.fail {
            color: #ED4934;
          }
        }
        .exception-png {
          width: 80px;
          height: 80px;
        }
      }
    }
  }
}
</style>